import React, { useEffect, useState } from 'react';

import styles from './DogCardHDLatest.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../../Auth';
import { useAxios } from '../../../../../../AxiosHandler';
import SingleValueCard from '../../../../Statistics/Cards/SingleValueCard/SingleValueCard';

function DogCardHDLatest(props: DogCardHDLatestProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [data, setData] = useState<any>();
    
    function getData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/health/hd/latest",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setData(res.data);
            props.onDataLoaded?.(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (auth.selectedBreed != undefined) {
            getData();
        }
    }, [auth.selectedBreed]);

    return (
        <div className={styles.statisticshealth}>
            <SingleValueCard
                title={t("dog.statistics.hd.title")}
                data={data}
            ></SingleValueCard>
        </div>
    );
}

class DogCardHDLatestProps {
    dogId!: string | undefined;
    onDataLoaded?: (data: any) => void;
}

export default DogCardHDLatest;